import { Link } from "react-router-dom";
import "./Footer.scss";
import { MdClose } from "react-icons/md";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
function Footer() {
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [footerData, setFooterData] = useState("");
  const openModal = () => {
    getModalData(1);
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const openModal2 = () => {
    getModalData(2);
    setShowModal2(true);
  };
  const closeModal2 = () => {
    setShowModal2(false);
  };
  const openModal3 = () => {
    getModalData(3);
    setShowModal3(true);
  };
  const closeModal3 = () => {
    setShowModal3(false);
  };
  useEffect(() => {
    getFooterData();
  }, []);
  const [policyData, setPolicyData] = useState(null);
  const [ePolicyData, setEPolicyData] = useState(null);
  const [mapData, setMapData] = useState(null);
  const getFooterData = async () => {
    try {
      const response = await axios.get("/api/contents/type/6");
      setFooterData(response.data.contents);
    } catch (error) {
      console.log(error);
    }
  };
  const getModalData = async (type) => {
    try {
      const response = await axios.get(`/api/contents-type?type=${type}`);
      if (type === 1) {
        setPolicyData(response.data.contents);
      } else if (type === 2) {
        setEPolicyData(response.data.contents);
      } else {
        setMapData(response.data.contents);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {showModal ? (
        <div className="popup_bg_bbs" onClick={closeModal}>
          <div className="popup_bbs" onClick={(e) => e.stopPropagation()}>
            <div className="pophead_bbs">
              <h1>개인정보처리방침</h1>
            </div>
            <div className="pop_content">
              <div className="pop_content_inner">
                <div
                  className="jodit-wysiwyg"
                  dangerouslySetInnerHTML={{ __html: policyData }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {showModal2 ? (
        // <div className="popup_bg_bbs " onClick={closeModal2}>
        //   <div className="close_btn">
        //     <MdClose />
        //   </div>
        //   <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: ePolicyData }}></div>
        // </div>
        <div className="popup_bg_bbs" onClick={closeModal2}>
          <div className="popup_bbs" onClick={(e) => e.stopPropagation()}>
            <div className="pophead_bbs">
              <h1>이메일주소수집거부</h1>
              <span
                style={{ cursor: "pointer", zIndex: "100" }}
                className="close_btn"
                onClick={closeModal2}
              >
                <MdClose />
              </span>
            </div>
            <div className="pop_content">
              <div className="pop_content_inner">
                <div
                  className="jodit-wysiwyg"
                  dangerouslySetInnerHTML={{ __html: ePolicyData }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {showModal3 ? (
        // <div className="popup_bg_bbs " onClick={closeModal2}>
        //   <div className="close_btn">
        //     <MdClose />
        //   </div>
        //   <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: ePolicyData }}></div>
        // </div>
        <div className="popup_bg_bbs" onClick={closeModal3}>
          <div className="popup_bbs" onClick={(e) => e.stopPropagation()}>
            <div className="pophead_bbs">
              <h1>이메일주소수집거부</h1>
              <span
                style={{ cursor: "pointer", zIndex: "100" }}
                className="close_btn"
                onClick={closeModal3}
              >
                <MdClose />
              </span>
            </div>
            <div className="pop_content">
              <div className="pop_content_inner">
                <div
                  className="jodit-wysiwyg"
                  dangerouslySetInnerHTML={{ __html: mapData }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {/* {showModal3 ? (
        <div className="popup_bg_bbs" onClick={closeModal3}>
          <div className="popup_bbs" onClick={(e) => e.stopPropagation()}>
            <div className="pophead_bbs">
              <h1>찾아오시는길</h1>
            </div>
            <div className="pop_content">
              <div className="pop_content_inner">
                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: mapData }}></div>
              </div>
            </div>
          </div>
        </div>
      ) : null} */}

      <div className="footer row">
        <div className="col ">
          <div
            className="jodit-wysiwyg"
            dangerouslySetInnerHTML={{ __html: footerData }}
          ></div>
          {/* <div className="contain ">
            <div className="row">
              <div className="col foot_address">
                <p>
                  <strong>본사</strong> [15237] 경기도 상록구 성호로 31 (일동
                  707-2) ITS 인증 성능평가센터{" "}
                </p>
                <p>
                  <strong>Tel</strong> 031-478-0400{" "}
                  <span className="dividing_line">|</span> <strong>Fax</strong>{" "}
                  031-502-0549
                </p>
                <p className="copywrite">
                  Copyright 2021 ITS korea. All rights reserved.
                </p>
              </div>
            </div>
          </div> */}

          <div className="contain foot_top_bar">
            <Link
              to=""
              onClick={(e) => {
                e.preventDefault();
                openModal();
              }}
            >
              개인정보처리방침
            </Link>
            <span>|</span>
            <Link
              to=""
              onClick={(e) => {
                e.preventDefault();
                openModal2();
              }}
            >
              이메일무단수집거부
            </Link>
            <span>|</span>
            <Link to="/location">찾아오시는길</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
